<template>
    <SimpleModal v-if="showModal" @close="$emit('close')">
        <template v-slot:header>
            <h2>Contact {{ targetUser.public_name }}</h2>
        </template>
        <template v-slot:body>
            <div class="grid-2-col">
                <div class="form-group">
                    <label class="form-label required">First name</label>
                    <input
                        class="form-control"
                        :class="{ 'has-error': errors.first('first_name') }"
                        name="first_name"
                        v-model="formData.first_name"
                        v-validate="{ required: true, max: 50 }"
                        data-vv-as="first name" />
                    <span class="form-error">{{ errors.first('first_name') }}</span>
                </div>
                <div class="form-group">
                    <label class="form-label required">Last name</label>
                    <input
                        class="form-control"
                        :class="{ 'has-error': errors.first('last_name') }"
                        name="last_name"
                        v-model="formData.last_name"
                        v-validate="{ required: true, max: 20 }"
                        data-vv-as="last name" />
                    <span class="form-error">{{ errors.first('last_name') }}</span>
                </div>
                <div class="form-group">
                    <label class="form-label required">E-mail</label>
                    <input
                        class="form-control"
                        :class="{ 'has-error': errors.first('email') }"
                        autocomplete="off"
                        name="email"
                        v-model="formData.email"
                        v-validate="{ required: true }"
                        data-vv-as="email"
                        :readonly="user && user.email"/>
                    <span class="form-error">{{ errors.first('email') }}</span>
                </div>
                <div class="form-group">
                    <label class="form-label required">Phone number</label>
                    <input
                        type="tel"
                        ref="phone_number_e164"
                        name="phone_number_e164"
                        class="form-control"
                        :class="{ 'has-error': errors.first('phone_number_e164') }"
                        v-model="formData.phone_number_e164"
                        v-validate="{ required: true }"
                        data-vv-as="phone number"
                        :readonly="user && user.phone_number_e164"/>
                    <span class="form-error">{{ errors.first('phone_number_e164') }}</span>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label required">Your message</label>
                <textarea
                    class="form-control"
                    :class="{ 'has-error': errors.first('message') }"
                    style="min-height: 300px;"
                    autocomplete="off"
                    name="message"
                    v-model="formData.message"
                    v-validate="{ required: true }"
                    data-vv-as="message"></textarea>
                <span class="form-error">{{ errors.first('message') }}</span>
            </div>

            <div class="d-flex justify-content-start align-items-center gap-1">
                <button class="btn btn--primary" :disabled="isLoading" @click.prevent="contact">Send email</button>
                <Loader v-show="isLoading" />
            </div>

            <div class="form-note">
                <p>
                    By submitting this form, you agree to our <a href="/terms-and-conditions" target="_blank">Terms of Use</a> and <a href="/privacy-policy" target="_blank">Privacy Policy.</a> When you click 'Send email', we will share your personal information with the chosen estate agents, allowing them to respond to your request for information or to schedule a viewing.
                </p>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';
import telInput from '@helpers/tel-input';
import { mapState } from 'vuex';

const Loader = () => import('@components/partials/icons/Loader.vue');

export default {
    inject: ['$validator'],
    components: {
        SimpleModal,
        Loader,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        targetUser: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                first_name: '',
                last_name: '',
                email: '',
                phone_number_e164: '',
                message: '',
            },
            iti: null,
            isLoading: false,
        };
    },
    updated() {
        if (this.showModal) {
            this.iti = telInput(this.$refs.phone_number_e164);
        }
    },
    watch: {
        showModal(isOpened) {
            if (isOpened) {
                if (this.user) {
                    this.formData = {
                        first_name: this.user.firstname,
                        last_name: this.user.lastname,
                        email: this.user.email,
                        phone_number_e164: this.user.phone_number_e164,
                        message: '',
                    };
                } else {
                    this.formData = {
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone_number_e164: '',
                        message: '',
                    };
                }
                this.$validator.reset();
            }
        },
    },
    computed: {
        ...mapState('user', ['user']),
    },
    methods: {
        contact() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.axios.post(`/api/user/${this.targetUser.uuid || this.targetUser.slug}/contact`, { ...this.formData, phone_number_e164: this.iti.getNumber() })
                        .then(({ data }) => {
                            window.showToastSuccess('Sent successfully.');
                            this.$emit('close');
                        })
                        .catch(() => {
                            window.showToastError('Something went wrong.');
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            });
        },
    },
};
</script>
